module.exports = __webpack_public_path__ + "static/media/covid-19.d7265326.png";